/// <reference types="vite/client" />

import { defineChain } from "viem";

export enum NodeEnv {
  Local = "local",
  Development = "development",
  Staging = "staging",
  Production = "production",
}

const viteEnv = import.meta.env || {};

const currentNodeEnv = (viteEnv.VITE_ENV as NodeEnv) || NodeEnv.Local;

const isLocal = currentNodeEnv === NodeEnv.Local;
const isDevelopment = currentNodeEnv === NodeEnv.Development;
const isStaging = currentNodeEnv === NodeEnv.Staging;
const isProduction = currentNodeEnv === NodeEnv.Production;

export const env = {
  botUsername: viteEnv.VITE_BOT_USERNAME || "DefaultBot",
  apiBaseUrl: isLocal
    ? "/api"
    : viteEnv.VITE_API_BASE_URL || "https://api.bitton.com",
  isHttps: viteEnv.VITE_HTTPS === "true",
  nodeEnv: currentNodeEnv,
  isLocal,
  isDevelopment,
  isStaging,
  isProduction,
  manifestUrl:
    viteEnv.VITE_MANIFEST_URL ||
    "https://raw.githubusercontent.com/ton-connect/demo-telegram-bot/refs/heads/master/tonconnect-manifest.json",
  tonNetwork: viteEnv.VITE_TON_NETWORK ?? "mainnet",
  supportLink:
    viteEnv.VITE_SUPPORT || "https://t.me/Bitton_AI_Support_BOT?start=chat",
  reownProject:
    viteEnv.VITE_REOWN_PROJECT_ID || "abe25b7d005df3a3562daeea0758f9fa",
  baseTokenContractAddress:
    viteEnv.VITE_BASE_TOKEN_CONTRACT_ADDRESS ||
    "0xFb3BdF687d284D101663Db5804db771FF9Db826f",
  buyBtnLink:
    viteEnv.VITE_BY_BTN_LINK ||
    "https://app.uniswap.org/swap?inputCurrency=0xfde4c96c8593536e31f229ea8f37b2ada2699bb2&outputCurrency=0xFb3BdF687d284D101663Db5804db771FF9Db826f&chain=base",
};

const defaultBaseMainnetRpcs = [
  "https://mainnet.base.org",
  "https://base.api.pocket.network",
  "https://base-rpc.publicnode.com",
  "https://endpoints.omniatech.io/v1/base/mainnet/public",
  "https://base.meowrpc.com",
  "https://rpc.ankr.com/base/c664bc413faef403df9a404cb9b66761461d2d3fcc95328b946c1dd0111ca1ff",
];

const defaultBaseTestnetRpcs = ["https://sepolia.base.org"];

const getBaseRpcUrls = (): string[] => {
  const isTestnet = (viteEnv.VITE_BASE_NETWORK ?? "mainnet") === "testnet";
  const single = viteEnv.VITE_BASE_RPC_URL as string | undefined;

  const fallbacks = isTestnet ? defaultBaseTestnetRpcs : defaultBaseMainnetRpcs;

  const urls = [...(single ? [single] : []), ...fallbacks];

  return Array.from(new Set(urls));
};

const fallbackByNetwork = () => {
  const isTestnet = (viteEnv.VITE_BASE_NETWORK ?? "mainnet") === "testnet";
  return isTestnet
    ? {
        id: 84532,
        hex: "0x14A34",
        name: "Base Sepolia",
        rpc: "https://sepolia.base.org",
        explorer: "https://sepolia.basescan.org",
      }
    : {
        id: 8453,
        hex: "0x2105",
        name: "Base",
        rpc: "https://base.api.pocket.network",
        explorer: "https://basescan.org",
      };
};

export const getBaseChainFromEnv = () => {
  const fb = fallbackByNetwork();

  const id = Number(viteEnv.VITE_BASE_CHAIN_ID ?? fb.id);
  const name = viteEnv.VITE_BASE_CHAIN_NAME ?? fb.name;
  const rpcUrls = getBaseRpcUrls();
  const explorer = viteEnv.VITE_BASE_EXPLORER ?? fb.explorer;

  return defineChain({
    id,
    name,
    nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
    rpcUrls: {
      default: { http: rpcUrls },
      public: { http: rpcUrls },
    },
    blockExplorers: { default: { name: "explorer", url: explorer } },
  });
};
